"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KitDemo = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var kit_1 = require("@solana/kit");
var errors_1 = require("@hermis/errors");
var solana_headless_react_1 = require("@hermis/solana-headless-react");
var KitRpcContext_1 = require("../context/KitRpcContext");
require("./KitDemo.css");
// System Program Address
var SYSTEM_PROGRAM_ADDRESS = (0, kit_1.address)('11111111111111111111111111111111');
/**
 * Create a transfer SOL instruction using Kit types
 * This replaces @solana-program/system which has web3.js 2.0 dependency conflicts
 */
function getTransferSolInstruction(_a) {
    var source = _a.source, destination = _a.destination, amount = _a.amount;
    // System Program Transfer instruction layout:
    // [u32 instruction_index, u64 lamports]
    var instructionData = new Uint8Array(12);
    var view = new DataView(instructionData.buffer);
    view.setUint32(0, 2, true); // instruction discriminator: 2 = Transfer
    view.setBigUint64(4, BigInt(amount), true); // amount in lamports
    return {
        programAddress: SYSTEM_PROGRAM_ADDRESS,
        accounts: [
            { address: source.address, role: 3 }, // from account (writable + signer)
            { address: destination, role: 1 }, // to account (writable)
        ],
        data: instructionData,
    };
}
var WalletItem = function (_a) {
    var name = _a.name, icon = _a.icon, isSelected = _a.isSelected, onClick = _a.onClick;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "wallet-item ".concat(isSelected ? 'selected' : ''), onClick: onClick, children: [(0, jsx_runtime_1.jsx)("img", { src: icon, alt: "".concat(name, " icon"), onError: function (e) {
                    var target = e.target;
                    target.src = 'https://raw.githubusercontent.com/solana-labs/wallet-adapter/master/packages/wallets/icons/generic.svg';
                } }), (0, jsx_runtime_1.jsx)("div", { className: "wallet-info", children: (0, jsx_runtime_1.jsx)("div", { className: "wallet-name", children: name }) })] }));
};
function solStringToLamports(solQuantityString) {
    var _a, _b;
    if (Number.isNaN(parseFloat(solQuantityString))) {
        throw new Error('Could not parse token quantity: ' + String(solQuantityString));
    }
    var numDecimals = BigInt((_b = (_a = solQuantityString.split('.')[1]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
    var bigIntLamports = BigInt(solQuantityString.replace('.', '')) * Math.pow(10n, (9n - numDecimals));
    return (0, kit_1.lamports)(bigIntLamports);
}
var KitDemo = function () {
    var rpc = (0, react_1.useContext)(KitRpcContext_1.KitRpcContext).rpc;
    // Use hermis useWallet hook with Kit properties
    var _a = (0, solana_headless_react_1.useWallet)(), wallets = _a.wallets, wallet = _a.wallet, connected = _a.connected, connecting = _a.connecting, connect = _a.connect, disconnect = _a.disconnect, select = _a.select, walletAddress = _a.address, addressString = _a.addressString, messageSigner = _a.messageSigner, transactionSigner = _a.transactionSigner, chain = _a.chain, signAndSendTransaction = _a.signAndSendTransaction;
    var _b = (0, react_1.useState)(null), error = _b[0], setError = _b[1];
    // Sign message state
    var _c = (0, react_1.useState)(''), messageToSign = _c[0], setMessageToSign = _c[1];
    var _d = (0, react_1.useState)(false), isSigning = _d[0], setIsSigning = _d[1];
    var _e = (0, react_1.useState)(null), signature = _e[0], setSignature = _e[1];
    // Transaction state
    var _f = (0, react_1.useState)(''), recipientAddress = _f[0], setRecipientAddress = _f[1];
    var _g = (0, react_1.useState)(''), amount = _g[0], setAmount = _g[1];
    var _h = (0, react_1.useState)(false), isSendingTransaction = _h[0], setIsSendingTransaction = _h[1];
    var _j = (0, react_1.useState)(null), txSignature = _j[0], setTxSignature = _j[1];
    var handleSelectWallet = function (walletName) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setError(null);
                    return [4 /*yield*/, select(walletName)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.error('Wallet selection error:', err_1);
                    setError("Selection error: ".concat(err_1 instanceof Error ? err_1.message : 'Unknown error'));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleConnect = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!wallet) {
                        setError('Please select a wallet first');
                        return [2 /*return*/];
                    }
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, connect()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    console.error('Connection error:', err_2);
                    if ((0, errors_1.isHermisError)(err_2, errors_1.HERMIS_ERROR__WALLET_CONNECTION__FAILED)) {
                        setError("Failed to connect: ".concat(err_2.message));
                    }
                    else {
                        setError("Connection error: ".concat(err_2 instanceof Error ? err_2.message : 'Unknown error'));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleDisconnect = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setError(null);
                    return [4 /*yield*/, disconnect()];
                case 1:
                    _a.sent();
                    setSignature(null);
                    setTxSignature(null);
                    return [3 /*break*/, 3];
                case 2:
                    err_3 = _a.sent();
                    console.error('Disconnection error:', err_3);
                    setError("Disconnection error: ".concat(err_3 instanceof Error ? err_3.message : 'Unknown error'));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSignMessage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var messageBytes, result, messageSignature, signatureBase64, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!connected || !messageSigner || !walletAddress) {
                        setError('Wallet not connected or does not support message signing');
                        return [2 /*return*/];
                    }
                    if (!messageToSign.trim()) {
                        setError('Please enter a message to sign');
                        return [2 /*return*/];
                    }
                    setIsSigning(true);
                    setError(null);
                    setSignature(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    messageBytes = new TextEncoder().encode(messageToSign);
                    return [4 /*yield*/, messageSigner.modifyAndSignMessages([
                            {
                                content: messageBytes,
                                signatures: {},
                            },
                        ])];
                case 2:
                    result = (_a.sent())[0];
                    messageSignature = result === null || result === void 0 ? void 0 : result.signatures[walletAddress];
                    if (!messageSignature) {
                        throw new Error('Failed to get signature from message signer');
                    }
                    signatureBase64 = btoa(String.fromCharCode.apply(String, Array.from(messageSignature)));
                    setSignature(signatureBase64);
                    return [3 /*break*/, 5];
                case 3:
                    err_4 = _a.sent();
                    console.error('Sign message error:', err_4);
                    if ((0, errors_1.isHermisError)(err_4, errors_1.HERMIS_ERROR__SIGNING__MESSAGE_FAILED)) {
                        setError("Failed to sign message: ".concat(err_4.message));
                    }
                    else {
                        setError("Sign error: ".concat(err_4 instanceof Error ? err_4.message : 'Unknown error'));
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setIsSigning(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleSignAndSend = function () { return __awaiter(void 0, void 0, void 0, function () {
        var recipientAddr_1, amountLamports_1, latestBlockhash_1, message, signature_1, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!connected || !transactionSigner || !walletAddress) {
                        setError('Wallet not connected or does not support transactions');
                        return [2 /*return*/];
                    }
                    if (!recipientAddress.trim() || !amount.trim()) {
                        setError('Please enter recipient address and amount');
                        return [2 /*return*/];
                    }
                    setIsSendingTransaction(true);
                    setError(null);
                    setTxSignature(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    try {
                        recipientAddr_1 = (0, kit_1.address)(recipientAddress.trim());
                    }
                    catch (_b) {
                        setError('Invalid recipient address');
                        setIsSendingTransaction(false);
                        return [2 /*return*/];
                    }
                    try {
                        amountLamports_1 = solStringToLamports(amount);
                    }
                    catch (_c) {
                        setError('Invalid amount');
                        setIsSendingTransaction(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, rpc
                            .getLatestBlockhash({ commitment: 'confirmed' })
                            .send()
                        // Build transaction using Kit's pattern
                    ];
                case 2:
                    latestBlockhash_1 = (_a.sent()).value;
                    message = (0, kit_1.pipe)((0, kit_1.createTransactionMessage)({ version: 0 }), function (m) { return (0, kit_1.setTransactionMessageFeePayerSigner)(transactionSigner, m); }, function (m) { return (0, kit_1.setTransactionMessageLifetimeUsingBlockhash)(latestBlockhash_1, m); }, function (m) { return (0, kit_1.appendTransactionMessageInstruction)(getTransferSolInstruction({
                        amount: amountLamports_1,
                        destination: recipientAddr_1,
                        source: transactionSigner,
                    }), m); });
                    return [4 /*yield*/, signAndSendTransaction(message, rpc)];
                case 3:
                    signature_1 = _a.sent();
                    setTxSignature(signature_1);
                    setRecipientAddress('');
                    setAmount('');
                    return [3 /*break*/, 6];
                case 4:
                    err_5 = _a.sent();
                    console.error('Transaction error:', err_5);
                    if ((0, errors_1.isHermisError)(err_5, errors_1.HERMIS_ERROR__TRANSACTION__SEND_FAILED)) {
                        setError("Transaction failed: ".concat(err_5.message));
                    }
                    else {
                        setError("Transaction error: ".concat(err_5 instanceof Error ? err_5.message : 'Unknown error'));
                    }
                    return [3 /*break*/, 6];
                case 5:
                    setIsSendingTransaction(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "kit-demo-container", children: [(0, jsx_runtime_1.jsxs)("header", { className: "kit-demo-header", children: [(0, jsx_runtime_1.jsx)("h1", { children: "Kit Demo" }), (0, jsx_runtime_1.jsx)("p", { className: "subtitle", children: "Pure Kit Architecture with Hermis" })] }), error && ((0, jsx_runtime_1.jsxs)("div", { className: "error-banner", children: [(0, jsx_runtime_1.jsx)("strong", { children: "Error:" }), " ", error, (0, jsx_runtime_1.jsx)("button", { onClick: function () { return setError(null); }, className: "close-btn", children: "\u00D7" })] })), (0, jsx_runtime_1.jsxs)("div", { className: "kit-demo-content", children: [(0, jsx_runtime_1.jsxs)("section", { className: "section", children: [(0, jsx_runtime_1.jsx)("h2", { children: "1. Connect Wallet" }), !connected ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "wallet-grid", children: wallets.map(function (w) { return ((0, jsx_runtime_1.jsx)(WalletItem, { name: w.adapter.name, icon: w.adapter.icon, isSelected: (wallet === null || wallet === void 0 ? void 0 : wallet.adapter.name) === w.adapter.name, onClick: function () { return handleSelectWallet(w.adapter.name); } }, w.adapter.name)); }) }), (0, jsx_runtime_1.jsx)("button", { onClick: handleConnect, disabled: !wallet || connecting, className: "btn btn-primary", children: connecting ? 'Connecting...' : 'Connect Wallet' })] })) : ((0, jsx_runtime_1.jsxs)("div", { className: "connected-info", children: [(0, jsx_runtime_1.jsxs)("div", { className: "info-card", children: [(0, jsx_runtime_1.jsxs)("div", { className: "info-row", children: [(0, jsx_runtime_1.jsx)("span", { className: "label", children: "Wallet:" }), (0, jsx_runtime_1.jsx)("span", { className: "value", children: wallet === null || wallet === void 0 ? void 0 : wallet.adapter.name })] }), (0, jsx_runtime_1.jsxs)("div", { className: "info-row", children: [(0, jsx_runtime_1.jsx)("span", { className: "label", children: "Address:" }), (0, jsx_runtime_1.jsx)("span", { className: "value address", children: addressString })] }), (0, jsx_runtime_1.jsxs)("div", { className: "info-row", children: [(0, jsx_runtime_1.jsx)("span", { className: "label", children: "Chain:" }), (0, jsx_runtime_1.jsxs)("span", { className: "value", children: ["Devnet (", chain, ")"] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "info-row", children: [(0, jsx_runtime_1.jsx)("span", { className: "label", children: "Message Signer:" }), (0, jsx_runtime_1.jsx)("span", { className: "value", children: messageSigner ? '✓ Available' : '✗ Not available' })] }), (0, jsx_runtime_1.jsxs)("div", { className: "info-row", children: [(0, jsx_runtime_1.jsx)("span", { className: "label", children: "Transaction Signer:" }), (0, jsx_runtime_1.jsx)("span", { className: "value", children: transactionSigner ? '✓ Available' : '✗ Not available' })] })] }), (0, jsx_runtime_1.jsx)("button", { onClick: handleDisconnect, className: "btn btn-secondary", children: "Disconnect" })] }))] }), connected && messageSigner && ((0, jsx_runtime_1.jsxs)("section", { className: "section", children: [(0, jsx_runtime_1.jsx)("h2", { children: "2. Sign Message" }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "message", children: "Message to sign:" }), (0, jsx_runtime_1.jsx)("input", { id: "message", type: "text", value: messageToSign, onChange: function (e) { return setMessageToSign(e.target.value); }, placeholder: "Enter a message to sign", className: "input" })] }), (0, jsx_runtime_1.jsx)("button", { onClick: handleSignMessage, disabled: !messageToSign.trim() || isSigning, className: "btn btn-primary", children: isSigning ? 'Signing...' : 'Sign Message' }), signature && ((0, jsx_runtime_1.jsxs)("div", { className: "result-card success", children: [(0, jsx_runtime_1.jsx)("h3", { children: "\u2713 Message Signed Successfully!" }), (0, jsx_runtime_1.jsxs)("div", { className: "result-content", children: [(0, jsx_runtime_1.jsxs)("div", { className: "result-row", children: [(0, jsx_runtime_1.jsx)("span", { className: "result-label", children: "Message:" }), (0, jsx_runtime_1.jsx)("span", { className: "result-value", children: messageToSign })] }), (0, jsx_runtime_1.jsxs)("div", { className: "result-row", children: [(0, jsx_runtime_1.jsx)("span", { className: "result-label", children: "Signature:" }), (0, jsx_runtime_1.jsx)("span", { className: "result-value signature", children: signature })] })] })] }))] })), connected && transactionSigner && ((0, jsx_runtime_1.jsxs)("section", { className: "section", children: [(0, jsx_runtime_1.jsx)("h2", { children: "3. Sign and Send Transaction" }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "recipient", children: "Recipient Address:" }), (0, jsx_runtime_1.jsx)("input", { id: "recipient", type: "text", value: recipientAddress, onChange: function (e) { return setRecipientAddress(e.target.value); }, placeholder: "Enter recipient address", className: "input" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "amount", children: "Amount (SOL):" }), (0, jsx_runtime_1.jsx)("input", { id: "amount", type: "number", step: "0.001", value: amount, onChange: function (e) { return setAmount(e.target.value); }, placeholder: "0.001", className: "input" })] }), (0, jsx_runtime_1.jsx)("button", { onClick: handleSignAndSend, disabled: !recipientAddress.trim() || !amount.trim() || isSendingTransaction, className: "btn btn-primary", children: isSendingTransaction ? 'Sending...' : 'Sign and Send' }), txSignature && ((0, jsx_runtime_1.jsxs)("div", { className: "result-card success", children: [(0, jsx_runtime_1.jsx)("h3", { children: "\u2713 Transaction Sent Successfully!" }), (0, jsx_runtime_1.jsxs)("div", { className: "result-content", children: [(0, jsx_runtime_1.jsxs)("div", { className: "result-row", children: [(0, jsx_runtime_1.jsx)("span", { className: "result-label", children: "Signature:" }), (0, jsx_runtime_1.jsx)("span", { className: "result-value signature", children: txSignature })] }), (0, jsx_runtime_1.jsx)("div", { className: "result-row", children: (0, jsx_runtime_1.jsx)("a", { href: "https://explorer.solana.com/tx/".concat(txSignature, "?cluster=devnet"), target: "_blank", rel: "noopener noreferrer", className: "explorer-link", children: "View on Solana Explorer \u2192" }) })] })] }))] }))] })] }));
};
exports.KitDemo = KitDemo;
